import { usePaymentsQuery, useSpritzCardQuery } from '../../graphql/generated/graphql'
import React from 'react'
import styled from 'styled-components'
import { Card } from '../../components/Layout/Card'
import { Body, breakpoints, Margin, Spacer } from '@spritz-finance/ui'
import { Row } from '../../components/Layout/Row'
import { PaymentButton } from './payment/PaymentButton'
import { formatCurrency } from '../../utils/format'
import { FundingActivity } from './FundingActivity'
import { AccountDetails } from './AccountDetails'
import { SpritzCardScene } from './SpritzCardIframe'
import { IntroHeader } from './IntroHeader'
import { PageTitle } from '../../components/PageTitle'

export const BalanceRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 16px 24px;
    border: 1px solid #efefef;
    box-shadow: 8px 8px 20px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    align-items: center;
`

const CardCard = styled(Card)`
    width: 524px;
    max-width: 100vw;
    box-sizing: border-box;

    ${breakpoints.xsmall} {
        width: 100%;
        max-width: none;
        padding: 16px;
    }
`

const SpritzCardInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`

export const SpritzCardInfo = () => {
    const { data } = useSpritzCardQuery({
        fetchPolicy: 'cache-and-network',
    })
    const { data: paymentsData } = usePaymentsQuery({
        fetchPolicy: 'cache-and-network',
    })
    const cardPayments =
        paymentsData?.payments.filter((p) => p.accountId === data?.virtualCard?.id) ?? []

    const hasPayments = cardPayments.length > 0

    if (!data?.virtualCard) return null

    return (
        <SpritzCardInfoWrapper>
            <PageTitle>SpritzCard</PageTitle>
            <CardCard margin={Margin.Large}>
                {!hasPayments && <IntroHeader />}

                <SpritzCardScene />

                <BalanceRow>
                    <Body.Med>Current balance</Body.Med>
                    <Body.Bold size={22}>{formatCurrency(data.virtualCard.balance)}</Body.Bold>
                </BalanceRow>
                <Spacer height={24} />

                <Row align="center">
                    <PaymentButton account={data.virtualCard} />
                </Row>
                <Spacer height={32} />

                <AccountDetails card={data.virtualCard} />

                {hasPayments && <FundingActivity payments={cardPayments} />}
            </CardCard>
        </SpritzCardInfoWrapper>
    )
}
